import { Base } from "@studiometa/js-toolkit";
class FrameForm extends Base {
  /**
   * Config.
   */
  static config = {
    name: "FrameForm"
  };
  /**
   * Get the form action.
   */
  get action() {
    return this.$el.action;
  }
}
export {
  FrameForm
};
//# sourceMappingURL=FrameForm.js.map
